export default "__VITE_ASSET__omw6WM9___"